import React, { memo } from 'react';
import { timePosToY, NUM_MEASURE, GRID_EDIT_DIV, GRID_SUB_DIV, PRELOAD_LEN } from './lane';
import { EditContainer } from '../store/EditContainer';
import { fraction, Fraction } from 'mathjs';
import classNames from 'classnames';
import * as math from 'mathjs';

interface Props {
  panelScrollY: number;
  panelHeight: number;
}

export const HorizontalGrids: React.FC<Props> = memo(props => {
  const { verticalZoom } = EditContainer.useContainer();
  return (
    <div>
      {[...Array(NUM_MEASURE * GRID_EDIT_DIV)]
        .map((_, i) => fraction(i, GRID_EDIT_DIV) as Fraction)
        .filter(pos => {
          const y = timePosToY(pos, verticalZoom);
          return props.panelScrollY - props.panelHeight * PRELOAD_LEN < y &&
            y - 1 < props.panelScrollY + props.panelHeight * (1 + PRELOAD_LEN);
        })
        .map(pos =>
          <div
            key={pos.toString()}
            className={classNames('grid-h',
              math.equal(math.mod(pos, 1), 0) ? 'grid-measure' :
                math.equal(math.mod(math.multiply(pos, GRID_EDIT_DIV) as Fraction, GRID_SUB_DIV), 0) ? 'grid-sub' :
                  'grid-edit'
            )}
            style={{ top: timePosToY(pos, verticalZoom) - 1 }}>
          </div>
        )}
    </div>
  );
});
